import { Empty, Spin } from "antd";

const BAR_COLORS = [
    "#29abe2", // bright blue
    "#3dbef5", // light blue
    "#5ccbf7", // lighter blue
    "#7dd7f9", // pale blue
    "#9ee3fb", // very pale blue
];

const NULL_COLOR = "#d9534f";
const BLANK_COLOR = "#fa8c16";
const OTHERS_COLOR = "#8a9bae";

function getBarColor(value, index) {
    const lower = String(value || "").toLowerCase();
    if (lower === "null" || lower === "(null)") return NULL_COLOR;
    if (lower === "blank" || lower === "(blank)") return BLANK_COLOR;
    if (lower === "others" || lower === "other") return OTHERS_COLOR;
    return BAR_COLORS[index % BAR_COLORS.length];
}

function getDistributionRowKey(d, index) {
    if (d.distributionKey) return d.distributionKey;
    return `${d.bucketType || "value"}:${d.value || ""}:${d.count || 0}:${index}`;
}

function getDistributionTitle(d) {
    const value = d.value || "";
    if (d.valueTruncated) {
        return `${value} (truncated)`;
    }
    return value;
}

const ProfilingBarChart = ({ data, loading }) => {
    if (loading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 80 }}>
                <Spin size="small" />
            </div>
        );
    }

    if (!data || data.length === 0) {
        return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No distribution data" style={{ margin: "8px 0" }} />;
    }

    // Sort by count descending
    const sorted = [...data].sort((a, b) => (b.count || 0) - (a.count || 0));

    const maxCount = Math.max(...sorted.map((d) => d.count || 0));

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
            {sorted.map((d, idx) => {
                const widthPct = maxCount > 0 ? ((d.count || 0) / maxCount) * 100 : 0;
                const color = getBarColor(d.value, idx);

                return (
                    <div key={getDistributionRowKey(d, idx)} style={{ display: "flex", alignItems: "center", gap: 8, height: 20 }}>
                        {/* Label */}
                        <div
                            style={{
                                width: 80,
                                fontSize: 11,
                                color: "#555",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                flexShrink: 0,
                            }}
                            title={getDistributionTitle(d)}
                        >
                            {d.value}
                        </div>
                        {/* Bar track */}
                        <div
                            style={{
                                flex: 1,
                                height: 16,
                                backgroundColor: "#eee",
                                borderRadius: 2,
                                overflow: "hidden",
                            }}
                        >
                            <div
                                style={{
                                    width: `${widthPct}%`,
                                    height: "100%",
                                    backgroundColor: color,
                                    borderRadius: 2,
                                    transition: "width 0.3s ease",
                                }}
                            />
                        </div>
                        {/* Count */}
                        <div style={{ width: 50, textAlign: "right", fontSize: 11, color: "#444", flexShrink: 0 }}>
                            {d.count != null ? Number(d.count).toLocaleString() : "-"}
                        </div>
                        {/* Percentage */}
                        <div style={{ width: 42, textAlign: "right", fontSize: 11, color: "#444", flexShrink: 0 }}>
                            {d.percentage != null ? `${Number(d.percentage).toFixed(1)}%` : ""}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export { ProfilingBarChart };
export default ProfilingBarChart;
